import React, { useState } from 'react';
import Header from '../components/Header';
import Menu from '../components/Menu';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import ContactUsForm from '../components/ContactUsForm';
import Banner from '../components/Banner';

const ContactUs = () => {
    
    
  return (
    <>
      <Header />
    
    <ContactUsForm />
     <Banner />
      <Contact />
   <Footer />
    </>
  );
};

export default ContactUs;
